<template>
    <div>
        <div class="row">
            <div class="col-lg-9">
                <!-- Generato da claude — Checkout: layout compatto single-row -->
                <div class="card" style="margin-top:10px;">
                    <div class="card-header card-header-background">
                        <span class="dk-header-title"><i class="fal fa-fw fa-euro-sign me-1"></i> Il tuo Ordine</span>
                    </div>
                    <div class="card-body p-3">
                        <div class="row g-2 align-items-end">
                            <div class="col-12 col-md-auto dk-col-240">
                                <label class="form-label mb-1" style="font-size:.8rem;font-weight:700">Email</label>
                                <input type="email" class="form-control form-control-lg" v-model="ordine.EMAIL" autocomplete="email">
                            </div>
                            <div class="col-12 col-md-auto dk-col-180">
                                <label class="form-label mb-1" style="font-size:.8rem;font-weight:700">Telefono</label>
                                <input type="tel" class="form-control form-control-lg" v-model="ordine.TELEFONO">
                            </div>
                            <div class="col-12 col-md-auto dk-col-220">
                                <label class="form-label mb-1" style="font-size:.8rem;font-weight:700">Pagamento</label>
                                <select :disabled="true" class="form-control form-control-lg" v-model="ordine.FK_ID_MODALITA_PAGAMENTO">
                                    <option value="1">Carta di Credito</option>
                                </select>
                            </div>
                            <div class="col-12 col-md">
                                <label class="form-label mb-1" style="font-size:.8rem;font-weight:700">Note <span class="fw-normal text-muted">(opzionale)</span></label>
                                <input type="text" class="form-control form-control-lg" v-model="ordine.NOTE" placeholder="">
                            </div>
                            <div class="col-12 col-md-auto d-grid">
                                <button class="btn btn-success btn-lg" @click="booking()">
                                    <i class="fal fa-check fa-fw"></i> Avanti
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <Carrello :modalita="1" :noq="1"></Carrello>
            </div>
        </div>
    </div>
</template>
<script>

import Carrello from '@/components/common/Carrello.vue'


export default {
    name:"Checkout",
    components:{
        Carrello
    },props:[],
    data:function(){
        return{
            ordine:{FK_ID_MODALITA_CONSEGNA:1,ID_ORDINE:0,DATA_RICHIESTA_CONSEGNA:'',FK_ID_INDIRIZZO_PRECEDENTE:0,FK_ID_MODALITA_PAGAMENTO:1},
            arrayGiorniConsegna: new Array(),
            arrayComuniConsegna: new Array(),
            arrayIndirizziConsegna : new Array(),
            pagamentoOnlineAbilitato : 0,
            consegnaDomicilioAbilitata: 0,
        }
    },
    methods: {
        dataConsegnaChangeHandler : function(){
            this.ordine.ORA_RICHIESTA_CONSEGNA = "";
        },
        booking : function(){
            utils.ajax('deskalo/checkout/booking',this.ordine, (response) => {
                if (response.esito == 0){
                    this.$root.token_ordine = response.data.token;
                    global.router.push("Confirm");
                }
            });
        },
        indirizzoChangeHandler(){
            if (this.ordine.FK_ID_INDIRIZZO_PRECEDENTE > 0){
                var indirizzo = utils.array.select(this.arrayIndirizziConsegna,"ID_INDIRIZZO",this.ordine.FK_ID_INDIRIZZO_PRECEDENTE,1)[0];
                this.ordine.FK_ID_COMUNE_CONSEGNA = indirizzo.FK_ID_COMUNE;
                this.ordine.INDIRIZZO = indirizzo.INDIRIZZO;
                this.ordine.NOTE_CONSEGNA = indirizzo.NOTE;
            }
            else{
                this.ordine.FK_ID_COMUNE_CONSEGNA = 0;
                this.ordine.INDIRIZZO = "";
                this.ordine.NOTE_CONSEGNA = "";
            }
        }
    },
    computed: {
        slotConsegna : function(){
            if (this.ordine.DATA_RICHIESTA_CONSEGNA != ''){
                var giorno = utils.array.select(this.arrayGiorniConsegna,'DATA',this.ordine.DATA_RICHIESTA_CONSEGNA,1)[0];
                if (giorno != undefined){
                    return giorno.ARRAY_SLOT;
                }
            }
            return new Array();
        }
    },
    created : function(){
        this.ordine.EMAIL = this.$root.utente.EMAIL || '';
        const u = this.$root.utente;
        const s = this.$root.DESKALO_SOCIO_SELEZIONATO || {};
        this.ordine.TELEFONO = s.TELEFONO || u.CELLULARE || u.TELEFONO || '';
        utils.ajax('/ec/checkout/startup',{}, (response) => {
            this.arrayGiorniConsegna = response.data.GIORNI;
            this.arrayComuniConsegna = response.data.COMUNI;
            this.arrayIndirizziConsegna = response.data.INDIRIZZI;
            this.consegnaDomicilioAbilitata = response.data.CONSEGNA_DOMICILIO_ABILITATA;
            if (this.consegnaDomicilioAbilitata == 0){
                this.ordine.FK_ID_MODALITA_CONSEGNA = 1;
            }
            this.pagamentoOnlineAbilitato = response.data.PAGAMENTO_ONLINE_ABILITATO;
            this.ordine.FK_ID_MODALITA_PAGAMENTO = 1;
            /*if (this.pagamentoOnlineAbilitato == 0){
                this.ordine.FK_ID_MODALITA_PAGAMENTO = 2;
            }*/
        });
    },
}
</script>